import Keycloak from "keycloak-js";

const keycloak = new Keycloak({

  url: "https://auth.tonichub.io/",
  realm: "TonicX",
  clientId: "tonicx-react-client",

});

export default keycloak;
